import {getLanguage, setLanguage} from '@/shared/services/i18n';

export async function afterSignUp() {
  await setLanguage(getLanguage());
}
